var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29202 15.462L13.172 11.582L9.29202 7.70202C9.19944 7.60944 9.126 7.49953 9.07589 7.37856C9.02579 7.2576 9 7.12795 9 6.99702C9 6.86609 9.02579 6.73644 9.07589 6.61548C9.126 6.49451 9.19944 6.3846 9.29202 6.29202C9.3846 6.19944 9.49451 6.126 9.61548 6.07589C9.73644 6.02579 9.86609 6 9.99702 6C10.128 6 10.2576 6.02579 10.3786 6.07589C10.4995 6.126 10.6094 6.19944 10.702 6.29202L15.292 10.882C15.682 11.272 15.682 11.902 15.292 12.292L10.702 16.882C10.6095 16.9747 10.4996 17.0483 10.3786 17.0985C10.2577 17.1486 10.128 17.1745 9.99702 17.1745C9.86605 17.1745 9.73637 17.1486 9.6154 17.0985C9.49442 17.0483 9.38453 16.9747 9.29202 16.882C8.91202 16.492 8.90202 15.852 9.29202 15.462Z",
    fill: "#8F90A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNext);
export default __webpack_public_path__ + "static/media/page_next.86da3cc9c46f656877125dfcab70ad66.svg";
export { ForwardRef as ReactComponent };